import { Stack, styled } from '@mui/material'
import Iconfont from 'components/Iconfont'
import { useAtomValue } from 'jotai'
import { memo } from 'react'
import { orderModalTitleAtom, useCloseOrderModal } from '.'

export const OrderModalTitle = styled(Stack)`
  flex-direction: row;
  justify-content: space-between;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.color.text100};
  margin-bottom: 24px;
`
export const OrderDataWrap = styled(Stack)`
  img {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 12px;
  }
  span {
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: ${(props) => props.theme.color.text100};
  }
`
export const CloseIcon = styled(Stack)`
  .iconfont {
    color: ${(props) => props.theme.color.text40};
  }
`

export const ModalTitle = memo(() => {
  const title = useAtomValue(orderModalTitleAtom)
  const closeModal = useCloseOrderModal()
  return (
    <OrderModalTitle>
      <OrderDataWrap>{title}</OrderDataWrap>
      <CloseIcon onClick={closeModal}>
        <Iconfont name="icon-close2" size={20} />
      </CloseIcon>
    </OrderModalTitle>
  )
})
